import { compact } from 'lodash';

import Paragraph, { paragraphCommand } from './editor-buttons/Paragraph';
import Heading1, { heading1Command } from './editor-buttons/Heading1';
import Heading2, { heading2Command } from './editor-buttons/Heading2';
import BulletedList, { bulletedListCommand } from './editor-buttons/BulletedList';
import NumberedList, { numberedListCommand } from './editor-buttons/NumberedList';
import Quote, { quoteCommand } from './editor-buttons/Quote';
import CodeBlock, { codeblockCommand } from './editor-buttons/CodeBlock';
import Table, { tableCommand } from './editor-buttons/Table';
import SectionBreak, { sectionBreakCommand } from './editor-buttons/SectionBreak';
import Image, { imageCommand } from './editor-buttons/Image';
import Link, { linkCommand } from './editor-buttons/Link';
import Mention, { mentionCommand } from './editor-buttons/Mention';
import AddColumnBefore, { addColumnBeforeCommand } from './editor-buttons/table-buttons/AddColumnBefore';
import AddColumnAfter, { addColumnAfterCommand } from './editor-buttons/table-buttons/AddColumnAfter';
import DeleteColumn, { deleteColumnCommand } from './editor-buttons/table-buttons/DeleteColumn';
import AddRowAfter, { addRowAfterCommand } from './editor-buttons/table-buttons/AddRowAfter';
import AddRowBefore, { addRowBeforeCommand } from './editor-buttons/table-buttons/AddRowBefore';
import DeleteRow, { deleteRowCommand } from './editor-buttons/table-buttons/DeleteRow';
import DeleteTable, { deleteTableCommand } from './editor-buttons/table-buttons/DeleteTable';
import { FormattedMessage } from 'react-intl';

export const getEditorMenuItems = ({
  entityId,
  entityType,
  editor,
  linkEditorComponentId,
  showMentionOptions,
  showImageOption,
  isExtension = false,
}) => {
  return compact([
    {
      key: 'paragraph',
      commandName: 'paragraph',
      label: <Paragraph editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: paragraphCommand,
    },
    {
      key: 'heading1',
      commandName: 'heading1',
      label: <Heading1 editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: heading1Command,
    },
    {
      key: 'heading2',
      commandName: 'heading2',
      label: <Heading2 editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: heading2Command,
    },
    {
      key: 'divider-1',
      type: 'divider',
    },
    {
      key: 'bulletlist',
      commandName: 'bulletedlist',
      label: <BulletedList editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: bulletedListCommand,
    },
    {
      key: 'orderedlist',
      commandName: 'numberedlist',
      label: <NumberedList editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: numberedListCommand,
    },
    {
      key: 'divider-2',
      type: 'divider',
    },
    {
      key: 'quote',
      commandName: 'quote',
      label: <Quote editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: quoteCommand,
    },
    {
      key: 'codeblock',
      commandName: 'codeblock',
      label: <CodeBlock editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: codeblockCommand,
    },
    {
      key: 'table',
      commandName: 'table',
      label: <Table editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: tableCommand,
    },
    {
      key: 'sectionbreak',
      commandName: 'sectionbreak',
      label: <SectionBreak editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: sectionBreakCommand,
    },
    {
      key: 'divider-3',
      type: 'divider',
    },
    showImageOption && {
      key: 'image',
      commandName: 'image',
      label: (
        <Image
          editor={editor}
          showLabel
          isExtension={isExtension}
          indicateActive={false}
          entityId={entityId}
          entityType={entityType}
        />
      ),
      command: imageCommand(entityId, entityType),
    },
    linkEditorComponentId && {
      key: 'link',
      commandName: 'link',
      label: (
        <Link
          linkEditorComponentId={linkEditorComponentId}
          editor={editor}
          showLabel
          isExtension={isExtension}
          indicateActive={false}
        />
      ),
      command: linkCommand(linkEditorComponentId),
    },
    showMentionOptions && {
      key: 'mention',
      commandName: 'mention',
      label: <Mention editor={editor} showLabel isExtension={isExtension} indicateActive={false} />,
      command: mentionCommand,
    },
  ]);
};

export const getTableMenuItems = ({
  editor,
  isExtension = false,
}) => {
  return compact([
    {
      key: 'addColumnBefore',
      commandName: 'addcolumnbefore',
      label: <AddColumnBefore editor={editor} showLabel isExtension={isExtension} />,
      command: addColumnBeforeCommand,
    },
    {
      key: 'addColumnAfter',
      commandName: 'addcolumnafter',
      label: <AddColumnAfter editor={editor} showLabel isExtension={isExtension} />,
      command: addColumnAfterCommand,
    },
    {
      key: 'deleteColumn',
      commandName: 'deletecolumn',
      label: <DeleteColumn editor={editor} showLabel isExtension={isExtension} />,
      command: deleteColumnCommand,
    },
    {
      key: 'divider-1',
      type: 'divider',
    },
    {
      key: 'addRowBefore',
      commandName: 'addrowbefore',
      label: <AddRowBefore editor={editor} showLabel isExtension={isExtension} />,
      command: addRowBeforeCommand,
    },
    {
      key: 'addRowAfter',
      commandName: 'addrowafter',
      label: <AddRowAfter editor={editor} showLabel isExtension={isExtension} />,
      command: addRowAfterCommand,
    },
    {
      key: 'deleteRow',
      commandName: 'deleterow',
      label: <DeleteRow editor={editor} showLabel isExtension={isExtension} />,
      command: deleteRowCommand,
    },
    {
      key: 'divider-2',
      type: 'divider',
    },
    {
      key: 'deleteTable',
      commandName: 'deletetable',
      label: <DeleteTable editor={editor} showLabel isExtension={isExtension} />,
      command: deleteTableCommand,
    },
  ]);
};

